import { useMemo } from 'react';
import { buildStyledQrSvg } from '../lib/styledQr';

interface StyledQrProps {
  value: string;
  size?: number;
  label: string;
  /** Isotipo de la marca al centro (requiere corrección H; ocupa ~18 % del ancho). */
  withMark?: boolean;
}

export function StyledQr({ value, size = 240, label, withMark = true }: StyledQrProps) {
  const svg = useMemo(() => buildStyledQrSvg(value, withMark), [value, withMark]);

  return (
    <img
      src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
      width={size}
      height={size}
      alt={label}
      className="rounded-lg border border-line bg-white shadow-1"
    />
  );
}
